/* 物料接口 */
const matterApi = {
	list:"/mast/materialmng/material/list",//列表
	add:"/mast/materialmng/material/add",//新增
	edit:"/mast/materialmng/material/modify",//编辑
	find:"/mast/materialmng/material/find",//查找详情
	del:"/mast/materialmng/material/del",//删除
	restore:"/mast/materialmng/material/restore",//恢复删除
	price:"/mast/materialmng/material/price"//物料管理-查找物料财务数据
	
}

 
/* 物料类型 */ 
const matterTypeApi = {
	list:"/mast/matrlTypemng/MaterialType/select",//列表
	add:"/mast/matrlTypemng/MaterialType/add",//新增
	edit:"/mast/matrlTypemng/MaterialType/modify",//编辑
	find:"/mast/matrlTypemng/MaterialType/find",//查找详情
	del:"/mast/matrlTypemng/MaterialType/delete",//删除
	restore:"/mast/matrlTypemng/MaterialType/restore"//恢复删除
}

const matterGropApi = {
  list:"/mast/matGroupmng/materialGroup/select",//列表
  add:"/mast/matGroupmng/materialGroup/add",//新增
  edit:"/mast/matGroupmng/materialGroup/modify",//编辑
  find:"/mast/matGroupmng/materialGroup/find",//查找详情
  del:"/mast/matGroupmng/materialGroup/delete",//删除
  restore:"/mast/matGroupmng/materialGroup/restore"//恢复删除
};

/* 工厂接口 */
const factoryApi = {
	list:"/mast/factorymng/factory/list",//列表
	add:"/mast/factorymng/factory/add",//新增
	edit:"/mast/factorymng/factory/modify",//编辑
	find:"/mast/factorymng/factory/select",//查找详情
	del:"/mast/factorymng/factory/delete",//删除
	restore:"/mast/factorymng/factory/restore",//恢复删除
	factoryFind:"/mast/factorymng/factory/find"//工厂管理-查找公司下的工厂列表
}
/* 工厂库存地 */
const fstockApi = {
	list:"/mast/factorymng/fctrInventory/list",//列表
	add:"/mast/factorymng/fctrInventory/add",//新增
	edit:"/mast/factorymng/fctrInventory/modify",//编辑
	find:"/mast/factorymng/fctrInventory/select",//查找详情
	del:"/mast/factorymng/fctrInventory/delete",//删除
	restore:"/mast/factorymng/fctrInventory/restore"//恢复删除
}

/* 供应商接口 */
const suplierApi = {
	list:"/mast/suppliermng/supplier/list",//列表
	add:"/mast/suppliermng/supplier/add",//新增
	edit:"/mast/suppliermng/supplier/modify",//编辑
	find:"/mast/suppliermng/supplier/find",//查找详情
	del:"/mast/suppliermng/supplier/del",//删除
	restore:"/mast/suppliermng/supplier/restore",//恢复删除
  group:"/vedAcountGroupmng/vendorAccountGroup/list",//供应商组
}

/* 客户接口 */
const customerApi = {
	list:"/mast/customerymng/customer/select",//列表
	add:"/mast/customerymng/customer/add",//新增
	edit:"/mast/customerymng/customer/modify",//编辑
	find:"/mast/customerymng/customer/find",//查找详情
	del:"/mast/customerymng/customer/delete",//删除
	restore:"/mast/customerymng/customer/restore",//恢复删除
	freeze:"/mast/customerymng/customer/freeze",//冻结
	unfreeze:"/mast/customerymng/customer/thaw",//冻结
}

/* 计量单位 */
const measureUnitApi = {
	list:"/mast/measureUnitmng/measureUnit/list",//列表
	add:"/mast/customerymng/customer/add",//新增
	edit:"/mast/measureUnitmng/measureUnit/modify",//编辑
	find:"/mast/measureUnitmng/measureUnit/find",//查找详情
	del:"/mast/measureUnitmng/measureUnit/delete",//删除
	restore:"/mast/measureUnitmng/measureUnit/restore"//恢复删除
}

const bomApi = {
	bomdefine:"/productplan/bom/bomdefine/mtrlbomversion",//BOM管理-获取物料BOM版本号
	list:"/productplan/bom/bomdefine/list",//列表
	add:"/productplan/bom/bomdefine/add",//新增
	edit:"/productplan/bom/bomdefine/modify",//编辑
	find:"/productplan/bom/bomdefine/findbombIll",//查找单个详情
	search:"/productplan/bom/bomdefine/search",//BOM管理-根据物料号和工厂查询bom版本
	del:"/productplan/bom/bomdefine/delete",//BOM管理-删除bom
	//缺少删除接口！！！
}


// 商品物料映射管理
const MatchGoodsMQApi = {
	list:"/ebus/materialrelatemage/materialrelate/select",//商品物料映射管理-查询商品物料映射列表
	add:"/ebus/materialrelatemage/materialrelate/add",//商品物料映射管理-添加商品物料映射
	edit:"/ebus/materialrelatemage/materialrelate/modify",//商品物料映射管理-修改商品物料映射
	find:"/ebus/materialrelatemage/materialrelate/find",//商品物料映射管理-查询商品物料映射
	del:"/ebus/materialrelatemage/materialrelate/delete",//商品物料映射管理-删除商品物料映射
	restore:"/ebus/materialrelatemage/materialrelate/restore"//商品物料映射管理-恢复已删除商品物料映射
}

// 物料类别管理
const MatcatmanageApi = {
	list:"/mast/matGroupmng/materialGroup/select",//物料类别管理-查询物料类别列表
	add:"/mast/matGroupmng/materialGroup/add",//物料类别管理-添加物料组
	modify:"/mast/matGroupmng/materialGroup/modify",//物料类别管理-修改物料类别
	find:"/mast/matGroupmng/materialGroup/find",//物料类别管理-查询物料类别
	del:"/mast/matGroupmng/materialGroup/delete",//物料类别管理-删除物料类别
	restore:"/mast/matGroupmng/materialGroup/restore"//物料类别管理-恢复已删除物料类别
}

// 计量单位管理
const UnitmanageApi = {
	list:"/mast/measureUnitmng/measureUnit/list",//计量单位管理-查询计量单位
	add:"/mast/measureUnitmng/measureUnit/add",//计量单位管理-添加计量单位
	modify:"/mast/measureUnitmng/measureUnit/modify",//计量单位管理-修改计量单位
	find:"/mast/measureUnitmng/measureUnit/find",//计量单位管理-查询计量单位
	del:"/mast/measureUnitmng/measureUnit/delete",//计量单位管理-删除计量单位
	restore:"/mast/measureUnitmng/measureUnit/restore"//计量单位管理-恢复已删除计量单位
}


export{
	matterApi,
	matterTypeApi,
  matterGropApi,
	factoryApi,
	fstockApi,
	suplierApi,
	customerApi,
	measureUnitApi,
	bomApi,
	MatchGoodsMQApi,
	MatcatmanageApi,
	UnitmanageApi
}
